import { store } from '@/app/store'
import { adminPortalApi } from '@/data/admin/api/admin_portal_api'
import type {
  AboutContent,
  KeysSettings,
  SupportSettings,
  TimezoneSettings,
} from '@/domain/settings/entities/settings.entity'

export class SettingsPortalRtkDatasource {
  async getSupport(): Promise<SupportSettings> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.getSupportSettings.initiate()
    )
    if (result.error) throw result.error
    return result.data ?? { email: '', mobileNumber: '' }
  }

  async saveSupport(payload: SupportSettings): Promise<void> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.saveSupportSettings.initiate(payload)
    )
    if (result.error) throw result.error
  }

  async getKeys(): Promise<KeysSettings> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.getApiKeysSettings.initiate()
    )
    if (result.error) throw result.error
    return (
      result.data ?? { fcmKey: '', twilioAccountSid: '', twilioAuthToken: '' }
    )
  }

  async saveKeys(payload: KeysSettings): Promise<void> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.saveApiKeysSettings.initiate(payload)
    )
    if (result.error) throw result.error
  }

  async getTimezone(): Promise<TimezoneSettings> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.getTimezoneSettings.initiate()
    )
    if (result.error) throw result.error
    return result.data ?? { timezone: '' }
  }

  async saveTimezone(payload: TimezoneSettings): Promise<void> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.saveTimezoneSettings.initiate(payload)
    )
    if (result.error) throw result.error
  }

  async getAboutContent(): Promise<AboutContent> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.getAboutContent.initiate()
    )
    if (result.error) throw result.error
    return result.data ?? { title: '', description: '' }
  }

  async saveAboutContent(payload: AboutContent): Promise<void> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.saveAboutContent.initiate(payload)
    )
    if (result.error) throw result.error
  }
}
